import React, {useState} from "react";
import { Button, Heading, Columns, Table } from 'react-bulma-components';
import { db } from '../firestore';
import { doc, addDoc, setDoc, getDoc, getDocs, collection, query, where, GeoPoint } from 'firebase/firestore'
import './SensorData.css';
import FlameGraph from "../graphs/FlameGraph";
import SmokeGraph from "../graphs/SmokeGraph";
import MQ4Graph from "../graphs/MQ4Graph";
import LPGGraph from "../graphs/LPGGraph";
import TemperatureGraph from "../graphs/TemperatureGraph";
import COGraph from "../graphs/COGraph";
import CO2Graph from "../graphs/CO2Graph";


function SensorDataBox() {

    const setNewSensorData = async (id, time, temp, lpg, co, smoke, mq4, co2, flame) => {
        await setDoc(doc(db, "Users/shadab.choudhury@northsouth.edu/HomeSensor", id), {
            time: time,
            temp: temp,
            lpg: lpg,
            co: co,
            smoke: smoke,
            mq4: mq4,
            co2: co2,
            flame: flame,
        });
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    let userType

    async function loadUserType() {
        const docRef = doc(db, "Users", readCookie("Username"));
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            userType = docSnap.data()["TypeofUser"]

        } else {
            console.log("No such document!");
        }
    }

    loadUserType().then(response => {

        console.log("User Type:", userType);
        const element = document.getElementById("Selector");

        if (userType === "NormalUser") {
            element.style.display = 'None';
        }
    });

    let nameFixed

    function nameInTitle(input) {
        let uName = input.split("@")[0];
        nameFixed = uName[0].charAt(0).toUpperCase() + uName.slice(1);
        console.log(uName)
    }

    nameInTitle(readCookie("Username"))

    async function loadData(uName) {

        const querySnapshot = await getDocs(collection(db, "Users", uName, "HomeSensor"))
        querySnapshot.forEach((doc) => {
            let table = document.getElementById('sensor-data');
            let row = document.createElement('tr');
            let cell1 = row.insertCell();
            cell1.textContent = doc.data()["time"]
            let cell2 = row.insertCell();
            cell2.textContent = doc.data()["temp"]
            let cell3 = row.insertCell();
            cell3.textContent = doc.data()["lpg"]
            let cell4 = row.insertCell();
            cell4.textContent = doc.data()["co"]
            let cell5 = row.insertCell();
            cell5.textContent = doc.data()["smoke"]
            let cell6 = row.insertCell();
            cell6.textContent = doc.data()["mq4"]
            let cell7 = row.insertCell();
            cell7.textContent = doc.data()["co2"]
            let cell8 = row.insertCell();
            cell8.textContent = doc.data()["flame"]
            table.appendChild(row);
            // setNewSensorData(data[i].time.concat("-", data[i].no), data[i].time, data[i].temp, data[i].lpg, data[i].co, data[i].smoke, data[i].mq4, data[i].co2, data[i].flame)

        });

    }

    if (readCookie("Username") !== null) {
        loadData(readCookie("Username"))
    }

    const [userN, setUserN] = useState({});

    const handleChange = (event) => {
        const name = event.target.name;
        const uN = event.target.value
        console.log("Current User:", uN)
        setUserN(values => ({...values, [name]: uN}))

        let table = document.getElementById('sensor-data');
        table.innerHTML = ""
        nameInTitle(uN)
        loadData(uN).then(r => null)

    }

    let NamesArray = [
        {label: "shadabchoudhury@gmail.com", value: "shadabchoudhury@gmail.com"},
        {label: "shadab.choudhury@northsouth.edu", value: "shadab.choudhury@northsouth.edu"},
        {label: "namerlight@gmail.com", value: "namerlight@gmail.com"},
    ]

    return (
        <div className={"fullCardLayoutStyle"} style={{minHeight: "800px", height:"80vh"}}>
            <Columns>
                <Columns.Column>
                    <Heading className={"has-text-centered"}>
                        Home Data for <span id={"user-name"}>{nameFixed}</span>
                        <span>
                            <select value={userN.value} name="userN" onChange={handleChange} id={"Selector"} style={{backgroundColor: "#325a79", borderColor: "#325a79", color: "white", marginLeft: "20%"}}>
                                {NamesArray.map((userNm) => <option value={userNm.value}>{userNm.label}</option>)}
                            </select>
                        </span>
                    </Heading>
                </Columns.Column>
            </Columns>
            <Columns gap="0">
                <Columns.Column>
                    <TemperatureGraph />
                </Columns.Column>
                <Columns.Column>
                    <LPGGraph />

                </Columns.Column>
                <Columns.Column>
                    <COGraph />

                </Columns.Column>
                <Columns.Column>
                    <SmokeGraph />

                </Columns.Column>
                <Columns.Column>
                    <MQ4Graph />

                </Columns.Column>
                <Columns.Column>
                    <CO2Graph />

                </Columns.Column>
                <Columns.Column>
                    <FlameGraph />

                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table size="fullwidth">
                        <thead>
                        <tr>
                            <th>Time</th>
                            <th>Temperature</th>
                            <th>LPG</th>
                            <th>CO</th>
                            <th>Smoke</th>
                            <th>MQ4</th>
                            <th>CO2</th>
                            <th>Flame</th>
                        </tr>
                        </thead>
                        <tbody id={"sensor-data"}>

                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    );

}


export default SensorDataBox;
